import { useLoader } from '@react-three/fiber'
import { useMemo } from 'react'
import * as THREE from 'three'
import { MeshPhysicalMaterial } from 'three'
import { TextureLoader } from 'three/src/loaders/TextureLoader'

const prefix = 'texture/'
const paths = [
  prefix + 'SolarCells_albedo.png',
  prefix + 'SolarCells_rough.png',
  prefix + 'SolarCells_normal.png',
  prefix + 'SolarCells_metal.png',
]

let material: MeshPhysicalMaterial | undefined

export const useSolarPanelMaterial = () => {
  const [albedoMap, roughnessMap, metalnessMap, normalMap] = useLoader(
    TextureLoader,
    paths
  )

  return useMemo(() => {
    if (!material) {
      material = new MeshPhysicalMaterial({
        name: 'SolarPanelMaterial',
        color: '#828282',
        map: albedoMap,
        normalMap: normalMap,
        normalScale: new THREE.Vector2(0.1, 0.1),
        roughnessMap: roughnessMap,
        roughness: 0.95,
        metalnessMap: metalnessMap,
        specularIntensity: 0.001,
        side: THREE.DoubleSide,
        metalness: 0.7,
      })
    }

    return material
  }, [albedoMap, roughnessMap, metalnessMap, normalMap])
}
